import { Link, useSearchParams } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { XCircle, RefreshCw, Mail, ArrowLeft, LogIn } from 'lucide-react'

export default function SubscriptionFailedPage() {
  const [searchParams] = useSearchParams()
  const { isAuthenticated } = useAuth0()
  const orderId = searchParams.get('oid')

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-md w-full text-center">
        {/* Error icon */}
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full">
            <XCircle className="w-12 h-12 text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Płatność nie powiodła się
        </h1>

        {/* Description */}
        <p className="text-lg text-gray-600 mb-8">
          {isAuthenticated
            ? 'Niestety nie udało się przetworzyć płatności. Sprawdź dane karty lub spróbuj ponownie za chwilę.'
            : 'Niestety nie udało się przetworzyć płatności. Twoje konto zostało utworzone z 7-dniowym okresem próbnym. Możesz się zalogować i ponowić płatność później.'}
        </p>

        {/* Order info */}
        {orderId && (
          <div className="bg-white rounded-lg shadow-sm p-4 mb-8">
            <p className="text-sm text-gray-500">
              Numer zamówienia: <span className="font-mono">{orderId.slice(0, 8)}...</span>
            </p>
          </div>
        )}

        {/* Possible reasons */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8 text-left">
          <h3 className="font-medium text-yellow-800 mb-2">Możliwe przyczyny:</h3>
          <ul className="text-sm text-yellow-700 space-y-1">
            <li>- Niewystarczające środki na karcie</li>
            <li>- Błędne dane karty płatniczej</li>
            <li>- Transakcja została odrzucona przez bank</li>
            <li>- Przekroczony limit płatności online</li>
          </ul>
        </div>

        {/* Action buttons */}
        <div className="space-y-3">
          {isAuthenticated ? (
            <>
              <a
                href="https://www.lextool.pl/cennik"
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Spróbuj ponownie
              </a>
              <Link
                to="/"
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-white text-gray-700 font-medium rounded-lg hover:bg-gray-50 shadow-sm transition-colors"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Wróć do strony głównej
              </Link>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Zaloguj się (masz 14 dni próbnych)
              </Link>
              <a
                href="https://www.lextool.pl/cennik"
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-white text-gray-700 font-medium rounded-lg hover:bg-gray-50 shadow-sm transition-colors"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Spróbuj ponownie z inną metodą płatności
              </a>
            </>
          )}
        </div>

        {/* Support info */}
        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <div className="flex items-center justify-center text-blue-700 mb-2">
            <Mail className="w-5 h-5 mr-2" />
            <span className="font-medium">Potrzebujesz pomocy?</span>
          </div>
          <p className="text-sm text-blue-600">
            Skontaktuj się z nami na{' '}
            <a href="mailto:support@lextool.pl" className="underline">
              support@lextool.pl
            </a>
            {' '}lub zadzwoń pod numer{' '}
            <a href="tel:+48123456789" className="underline">
              +48 123 456 789
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
